<div class="header-container">
  <h1 class="header-title">Alert Status</h1>
</div>
<div class="content">
  <nz-spin nzTip="Loading..." [nzSpinning]="loading">
    <form nz-form nzLayout="vertical">
      <nz-form-item>
        <nz-form-label>Message</nz-form-label>
        <nz-form-control>
          <input nz-input [(ngModel)]="alert.message" name="message" maxlength="135" placeholder="Enter alert message"
            width="100%" />
          <div class="char-counter">
            {{ alert.message.length }}/135
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>Color</nz-form-label>
        <nz-form-control>
          <nz-radio-group [(ngModel)]="alert.color" name="color">
            <label nz-radio *ngFor="let color of colors" [nzValue]="color" class="color-option">
              <span class="color-box" [style.background]="color"></span>
            </label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <div class="actions">
            <button type="button" nz-button nzType="primary" (click)="save()" [disabled]="!alert.message">
              Save
            </button>
            <button type="button" nz-button nzDanger nzType="default" (click)="deleteAlertStatus()">
              Delete
            </button>
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </nz-spin>
</div>